/* eslint-disable */
export default {
  to: 'À',
  enterNameOrNumber: 'Saisir un nom ou numéro',
} as const;

// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter name or number"@#@
